<template>
  <home-header
    :fixed="fixed"
    :translate-menu="translateMenu"
    :tool-menu="toolMenu"
    :user-info="userInfo"
    :group-user-info="groupUserInfo"
    :group-user-infos="groupUserInfos"
    :showlogin-out="showloginOut"
    :is-show-in-roaming="isShowInRoaming"
    :show-roaming="showRoaming"
    :qrcode-url="qrcodeUrl"
    @navigate="handleNavigate"
    @translate="handleTranslate"
    @tool="handleTool"
    @services="handleServices"
    @partners="handlePartners"
    @command="handleCommand"
    @institution-login="handleInstitutionLogin"
    @login="handleLogin"
    @register="handleRegister"
    @qrcode-show="getQrcode"
    @qrcode-hide="removeQrcode"
  />
</template>

<script>
import { Base64 } from 'js-base64'
import HomeHeader from './HomeHeader.vue'
import { authServiceClient, translateServiceClient } from '@/tools/api/service'
import { outRequest, userPowerRequest, userStatusRequest } from '@/tools/api/auth-api'
import { checkRoamingRequest, uploadTipRequest } from '@/tools/api/translate-api'

export default {
  name: 'SiteHeader',
  components: { HomeHeader },
  props: {
    fixed: { type: Boolean, default: false }
  },
  data () {
    return {
      translateMenu: [
        { label: '文本翻译', desc: '支持304种语言、近4万个翻译方向', type: 'text', icon: 'el-icon-document' },
        { label: '文档翻译', desc: '一键上传，高度保留原文样式排版', type: 'doc', icon: 'el-icon-folder' },
        { label: 'AI翻译', desc: 'AI驱动，精准流畅的多语言转换', type: 'ai', icon: 'el-icon-cpu' },
        { label: '多语种翻译', desc: '保留原文译文对应关系', type: 'lange', icon: 'el-icon-connection' },
        { label: '图片翻译', desc: '粘贴图片即可识别文本快速翻译', type: 'img', icon: 'el-icon-picture-outline' },
        { label: '网页翻译', desc: '快速翻译任意网页内容', type: 'webTranslate', icon: 'el-icon-monitor' }
      ],
      toolMenu: [
        { label: '润色改写', desc: '智能润色，提升文章表达质量', action: 'polish', icon: 'el-icon-magic-stick' },
        { label: 'AI PPT', desc: 'AI一键生成专业演示文稿', action: 'aiPPT', icon: 'el-icon-data-board' },
        { label: 'RAG知识库', desc: '构建专属知识库，精准检索', action: 'rag', icon: 'el-icon-collection' },
        { label: '人工翻译', desc: '汇集全球海量人才，权威翻译团队', action: 'toTransPro', icon: 'el-icon-service' },
        { label: '术语词库', desc: '设定规则，提高译文一致性', action: 'standLangSet', icon: 'el-icon-notebook-2' },
        { label: '文档转换', desc: '多格式文档互转，高保真输出', action: 'convertDoc', icon: 'el-icon-document-copy' },
        { label: '数据分析', desc: 'AI智能抓取分析，生成RAG报告', action: 'smartClassify', icon: 'el-icon-data-analysis' },
        { label: '我的文档', desc: '翻译记录管理，便捷查找历史', action: 'mySelfDoc', icon: 'el-icon-folder-opened' },
        { label: '聚合数据库检索', desc: '聚合开放获取文献，快速检索DOI、引用和PDF', action: 'scholar', icon: 'el-icon-search' },
        { label: '分类预测', desc: '上传Excel批量预测内容分类', action: 'categoryTool', icon: 'el-icon-s-grid' },
        { label: '素材提取', desc: '从 Word / PDF 提取目录、表格、图片等素材', action: 'materialExtract', icon: 'el-icon-files' }
      ],
      userInfo: '',
      groupUserInfo: '',
      groupUserInfos: [],
      showloginOut: false,
      isShowInRoaming: false,
      showRoaming: false,
      qrcodeUrl: '',
      userId: '',
      userType: '',
      isRoamingTimer: null,
      isRoamingTimerOut: null
    }
  },
  created () {
    this.syncUserInfoFromStorage()
    this.syncHeaderUserStatus()
    this.loadRoamingAvailability()
  },
  mounted () {
    window.addEventListener('message', this.handleAuthMessage)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.handleAuthMessage)
    this.removeQrcode()
  },
  methods: {
    hasListener (name) {
      return typeof this.$listeners[name] === 'function'
    },
    handleNavigate (path) {
      if (this.hasListener('navigate')) return this.$emit('navigate', path)
      return this.toPath(path)
    },
    handleTranslate (type) {
      if (this.hasListener('translate')) return this.$emit('translate', type)
      return this.gotoPage(type)
    },
    handleTool (action) {
      if (this.hasListener('tool')) return this.$emit('tool', action)
      if (['polish', 'aiPPT', 'rag', 'scholar', 'categoryTool'].includes(action)) return this.gotoPage(action)
      return this.logOut(action)
    },
    handleServices () {
      if (this.hasListener('services')) return this.$emit('services')
      return this.$router.push('/about')
    },
    handlePartners () {
      if (this.hasListener('partners')) return this.$emit('partners')
      return this.toPath('/partners')
    },
    handleCommand (command) {
      if (this.hasListener('command')) return this.$emit('command', command)
      return this.logOut(command)
    },
    handleInstitutionLogin () {
      if (this.hasListener('institution-login')) return this.$emit('institution-login')
      return this.openAuth('/login')
    },
    handleLogin () {
      if (this.hasListener('login')) return this.$emit('login')
      return this.openAuth('/login')
    },
    handleRegister () {
      if (this.hasListener('register')) return this.$emit('register')
      return this.openAuth('/register')
    },
    openAuth (path) {
      if (window.matchMedia('(max-width: 768px)').matches) {
        return this.$router.push(path === '/register' ? '/h5/register' : '/h5/login')
      }
      const url = path === '/login' ? (process.env.VUE_APP_WEB_LOGIN_URL || path) : path
      return this.$authPopup.open(url)
    },
    syncUserInfoFromStorage () {
      const authContext = localStorage.getItem('auth-context')
      if (!authContext) {
        this.resetHeaderUserState()
        return
      }
      try {
        const users = JSON.parse(authContext)
        this.resetHeaderUserState()
        users.forEach(item => {
          if (item.type === 'Person' || item.type === 'Child') {
            this.userInfo = this.safeDecodeName(item)
            this.userId = item.name
            this.userType = item.type === 'Person' ? '0' : '1'
            if (!item.isRoaming) {
              this.showRoaming = localStorage.getItem(this.userId) !== '1'
            } else {
              this.userType = '2'
            }
            if (!this.groupUserInfo) this.groupUserInfo = '机构登录'
            this.showloginOut = true
          }
          if (item.type === 'Group') {
            this.groupUserInfos.push(item)
            this.groupUserInfo = this.safeDecodeName(item)
          }
        })
      } catch (e) {
        this.resetHeaderUserState()
      }
    },
    safeDecodeName (item) {
      if (!item) return ''
      if (item.realName !== '' && item.realName !== undefined) {
        try { return Base64.decode(item.realName) } catch (e) { return item.name || '' }
      }
      return item.name || ''
    },
    syncHeaderUserStatus () {
      const token = localStorage.getItem('token')
      if (!token) return this.syncUserInfoFromStorage()
      authServiceClient.getUserStatus(userStatusRequest, { token }).then(res => {
        if (!res.getStatus()) {
          localStorage.removeItem('token')
          localStorage.removeItem('auth-context')
          this.resetHeaderUserState()
          return
        }
        this.syncUserInfoFromStorage()
      }).catch(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('auth-context')
        this.resetHeaderUserState()
      })
    },
    loadRoamingAvailability () {
      translateServiceClient.getUploadTip(uploadTipRequest, {
        token: localStorage.getItem('token')
      }).then(res => {
        this.isShowInRoaming = res.getIsRoaming()
      }).catch(() => {
        this.isShowInRoaming = false
      })
    },
    resetHeaderUserState () {
      this.userInfo = ''
      this.groupUserInfo = ''
      this.groupUserInfos = []
      this.showloginOut = false
      this.showRoaming = false
      this.userId = ''
      this.userType = ''
    },
    handleAuthMessage (event) {
      const payload = event && event.data
      const action = typeof payload === 'string' ? payload : payload && (payload.type || payload.data)
      if (action === 'params') this.openAuth('/login')
      if (action === 'close' || action === 'loginSuccess') {
        this.$authPopup.close()
        window.setTimeout(() => {
          this.syncHeaderUserStatus()
          this.loadRoamingAvailability()
          this.$emit('auth-updated')
        }, 120)
      }
    },
    gotoPage (type) {
      const routeMap = {
        text: ['/translate', 'txt'],
        doc: ['/translate', 'doc'],
        ai: ['/translate', 'AITranslate'],
        lange: ['/translate', 'more'],
        img: ['/translate', 'img'],
        polish: ['/translate', 'polish'],
        aiPPT: ['/translate', 'aiPPT'],
        webTranslate: ['/translate', 'plugin']
      }
      if (type === 'rag') return this.toPath('/rag')
      if (type === 'scholar') return this.toPath('/scholar')
      if (type === 'categoryTool') return this.toPath('/category-tool')
      if (type === 'pro') return this.toPath('/trans-pro')
      const target = routeMap[type]
      if (target) return this.toPath(target[0], target[1])
    },
    logOut (command) {
      const actionMap = {
        toTransPro: ['/trans-pro'],
        standLangSet: ['/translate', 'setting'],
        convertDoc: ['/translate', 'convert'],
        mySelfDoc: ['/list-pro'],
        webTranslate: ['/translate', 'plugin'],
        smartClassify: ['/smart-classify'],
        materialExtract: ['/extract']
      }
      if (command === 'toCenter' || command === 'toAccount') {
        window.open('https://user.wesitrans.com/account', '_blank')
        return
      }
      if (command === 'toOrder') {
        window.open('https://user.wesitrans.com/order', '_blank')
        return
      }
      if (actionMap[command]) return this.toPath(actionMap[command][0], actionMap[command][1])
      const request = outRequest
      request.setName(command === undefined ? this.userInfo : command)
      authServiceClient.logOut(request, { token: localStorage.getItem('token') }).then(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('auth-context')
        window.location.assign('/index')
      }).catch(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('auth-context')
        this.resetHeaderUserState()
        this.$router.push('/index')
        this.openAuth('/login')
      })
    },
    toPath (url, type) {
      if (url === '/trans-pro') {
        window.open('/trans-pro/index', '_self')
        return
      }
      if (url === '/list' || url === '/list-pro') {
        return authServiceClient.getUserStatus(userStatusRequest, {
          token: localStorage.getItem('token')
        }).then(res => {
          if (!res.getStatus()) throw new Error('login-required')
          return authServiceClient.checkUserPower(userPowerRequest, {
            token: localStorage.getItem('token')
          })
        }).then(res => {
          if (!res.getStatus()) {
            this.$message.error(res.getMessage())
            return this.openAuth('/login')
          }
          return this.pushRoute(url, type)
        }).catch(() => this.openAuth('/login'))
      }
      return this.pushRoute(url, type)
    },
    pushRoute (url, type) {
      if (type) return this.$router.push({ path: url, query: { type } })
      return this.$router.push(url)
    },
    getQrcode () {
      this.qrcodeUrl = 'http://common.wesitrans.com/common/roaming/qrcode'
      this.isRoamingTimer = window.setInterval(this.roamingEvent, 1000)
      this.isRoamingTimerOut = window.setTimeout(this.removeQrcode, 60000)
    },
    roamingEvent () {
      if (!this.userId || localStorage.getItem(this.userId) === '1') return
      const request = checkRoamingRequest
      request.setUserId(this.userId)
      translateServiceClient.checkRoaming(request, {
        token: localStorage.getItem('token')
      }).then(res => {
        localStorage.setItem(this.userId, res.getMessage())
        if (res.getMessage() === '1') window.location.reload()
      }).catch(() => {})
    },
    removeQrcode () {
      this.qrcodeUrl = ''
      window.clearInterval(this.isRoamingTimer)
      window.clearTimeout(this.isRoamingTimerOut)
      this.isRoamingTimer = null
      this.isRoamingTimerOut = null
    }
  }
}
</script>
